import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import BlindDisc from 'features/processFlowDiagrams/svg/fittings/blind-disc.svg?react'
import Breakthrough from 'features/processFlowDiagrams/svg/fittings/breakthrough.svg?react'
import ClampedFlangeCoupling from 'features/processFlowDiagrams/svg/fittings/clamped-flange-coupling.svg?react'
import Compensator from 'features/processFlowDiagrams/svg/fittings/compensator.svg?react'
import Coupling from 'features/processFlowDiagrams/svg/fittings/coupling.svg?react'
import FlameArrestor from 'features/processFlowDiagrams/svg/fittings/flame-arrestor.svg?react'
import FlameArrestorDetonationProof from 'features/processFlowDiagrams/svg/fittings/flame-arrestor-detonation-proof.svg?react'
import FlameArrestorExplosionProof from 'features/processFlowDiagrams/svg/fittings/flame-arrestor-explosion-proof.svg?react'
import FlameArrestorFireResistant from 'features/processFlowDiagrams/svg/fittings/flame-arrestor-fire-resistant.svg?react'
import FlameArrestorFireResistantDetonationProof from 'features/processFlowDiagrams/svg/fittings/flame-arrestor-fire-resistant-detonation-proof.svg?react'
import FlangedConnection from 'features/processFlowDiagrams/svg/fittings/flanged-connection.svg?react'
import FlangedDummyCover from 'features/processFlowDiagrams/svg/fittings/flanged-dummy-cover.svg?react'
import Funnel from 'features/processFlowDiagrams/svg/fittings/funnel.svg?react'
import Hose from 'features/processFlowDiagrams/svg/fittings/hose.svg?react'
import Injector from 'features/processFlowDiagrams/svg/fittings/injector.svg?react'
import InterchangeableDiscBlindDisc from 'features/processFlowDiagrams/svg/fittings/interchangeable-disc-blind-disc.svg?react'
import InterchangeableDiscOpenDiscInFunction from 'features/processFlowDiagrams/svg/fittings/interchangeable-disc-open-disc-in-function.svg?react'
import OpenDisc from 'features/processFlowDiagrams/svg/fittings/open-disc.svg?react'
import OrificePlate from 'features/processFlowDiagrams/svg/fittings/orifice-plate.svg?react'
import Reducer from 'features/processFlowDiagrams/svg/fittings/reducer.svg?react'
import RuptureDisc from 'features/processFlowDiagrams/svg/fittings/rupture-disc.svg?react'
import SelfOperatingReleaseValve from 'features/processFlowDiagrams/svg/fittings/self-operating-release-valve.svg?react'
import Silencer from 'features/processFlowDiagrams/svg/fittings/silencer.svg?react'
import SingleFlange from 'features/processFlowDiagrams/svg/fittings/single-flange.svg?react'
import Strainer from 'features/processFlowDiagrams/svg/fittings/strainer.svg?react'
import StrainerCone from 'features/processFlowDiagrams/svg/fittings/strainer-cone.svg?react'
import Vent from 'features/processFlowDiagrams/svg/fittings/vent.svg?react'
import ViewingGlass from 'features/processFlowDiagrams/svg/fittings/viewing-glass.svg?react'
import ViewingGlassLighting from 'features/processFlowDiagrams/svg/fittings/viewing-glass-lighting.svg?react'
import React from 'react'

export const PID_FITTINGS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'blind-disc',
    name: 'Blind Disc',
    category: 'fittings',
    svgContent: <BlindDisc />,
    viewBox: '0 0 40 140',
  },
  {
    id: 'breakthrough',
    name: 'Breakthrough',
    category: 'fittings',
    svgContent: <Breakthrough />,
    viewBox: '0 0 38 100',
  },
  {
    id: 'clamped-flange-coupling',
    name: 'Clamped Flange Coupling',
    category: 'fittings',
    svgContent: <ClampedFlangeCoupling />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'compensator',
    name: 'Compensator',
    category: 'fittings',
    svgContent: <Compensator />,
    viewBox: '0 0 40 80',
  },
  {
    id: 'coupling',
    name: 'Coupling',
    category: 'fittings',
    svgContent: <Coupling />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'flame-arrestor',
    name: 'Flame Arrestor',
    category: 'fittings',
    svgContent: <FlameArrestor />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'flame-arrestor-detonation-proof',
    name: 'Flame Arrestor (Detonation-Proof)',
    category: 'fittings',
    svgContent: <FlameArrestorDetonationProof />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'flame-arrestor-explosion-proof',
    name: 'Flame Arrestor (Explosion-Proof)',
    category: 'fittings',
    svgContent: <FlameArrestorExplosionProof />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'flame-arrestor-fire-resistant',
    name: 'Flame Arrestor (Fire-Resistant)',
    category: 'fittings',
    svgContent: <FlameArrestorFireResistant />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'flame-arrestor-fire-resistant-detonation-proof',
    name: 'Flame Arrestor (Fire-Resistant, Detonation-Proof)',
    category: 'fittings',
    svgContent: <FlameArrestorFireResistantDetonationProof />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'flanged-connection',
    name: 'Flanged Connection',
    category: 'fittings',
    svgContent: <FlangedConnection />,
    viewBox: '0 0 20 50',
  },
  {
    id: 'flanged-dummy-cover',
    name: 'Flanged Dummy Cover',
    category: 'fittings',
    svgContent: <FlangedDummyCover />,
    viewBox: '0 0 85 50',
  },
  {
    id: 'funnel',
    name: 'Funnel',
    category: 'fittings',
    svgContent: <Funnel />,
    viewBox: '0 0 80 140',
  },
  {
    id: 'hose',
    name: 'Hose',
    category: 'fittings',
    svgContent: <Hose />,
    viewBox: '0 0 180 30',
  },
  {
    id: 'injector',
    name: 'Injector',
    category: 'fittings',
    svgContent: <Injector />,
    viewBox: '0 0 80 40',
  },
  {
    id: 'interchangeable-disc-blind-disc',
    name: 'Interchangeable Disc (Blind Disc)',
    category: 'fittings',
    svgContent: <InterchangeableDiscBlindDisc />,
    viewBox: '0 0 40 140',
  },
  {
    id: 'interchangeable-disc-open-disc-in-function',
    name: 'Interchangeable Disc (Open Disc In Function)',
    category: 'fittings',
    svgContent: <InterchangeableDiscOpenDiscInFunction />,
    viewBox: '0 0 40 140',
  },
  {
    id: 'open-disc',
    name: 'Open Disc',
    category: 'fittings',
    svgContent: <OpenDisc />,
    viewBox: '0 0 40 140',
  },
  {
    id: 'orifice-plate',
    name: 'Orifice Plate',
    category: 'fittings',
    svgContent: <OrificePlate />,
    viewBox: '0 0 40 140',
  },
  {
    id: 'reducer',
    name: 'Reducer',
    category: 'fittings',
    svgContent: <Reducer />,
    viewBox: '0 0 70 50',
  },
  {
    id: 'rupture-disc',
    name: 'Rupture Disc',
    category: 'fittings',
    svgContent: <RuptureDisc />,
    viewBox: '0 0 50 100',
  },
  {
    id: 'self-operating-release-valve',
    name: 'Self-Operating Release Valve',
    category: 'fittings',
    svgContent: <SelfOperatingReleaseValve />,
    viewBox: '0 0 104 104',
  },
  {
    id: 'silencer',
    name: 'Silencer',
    category: 'fittings',
    svgContent: <Silencer />,
    viewBox: '0 0 140 100',
  },
  {
    id: 'single-flange',
    name: 'Single Flange',
    category: 'fittings',
    svgContent: <SingleFlange />,
    viewBox: '0 0 5 50',
  },
  {
    id: 'strainer',
    name: 'Strainer',
    category: 'fittings',
    svgContent: <Strainer />,
    viewBox: '0 0 40 80',
  },
  {
    id: 'strainer-cone',
    name: 'Strainer (Cone)',
    category: 'fittings',
    svgContent: <StrainerCone />,
    viewBox: '0 0 40 80',
  },
  {
    id: 'vent',
    name: 'Vent',
    category: 'fittings',
    svgContent: <Vent />,
    viewBox: '0 0 80 140',
  },
  {
    id: 'viewing-glass',
    name: 'Viewing Glass',
    category: 'fittings',
    svgContent: <ViewingGlass />,
    viewBox: '0 0 100 50',
  },
  {
    id: 'viewing-glass-lighting',
    name: 'Viewing Glass (Lighting)',
    category: 'fittings',
    svgContent: <ViewingGlassLighting />,
    viewBox: '0 0 100 100',
  },
]
